import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NextContestInfo } from '../interfaces/next-contest-info';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomepageDataService {

  constructor(
    private http: HttpClient
  ) { }

  private url = environment.urlWebServices + '/cwk/competition';

  // Read next contest
  readNext(studentId: number): Observable<NextContestInfo | null> {

    // Call web service
    const getURL = `${this.url}/next/${studentId}`;
    return this.http.get<NextContestInfo | null>(getURL)
      .pipe(
        map(response => this.fixNextContestFromMySQL(response))
      );
  }

  private fixNextContestFromMySQL(response): NextContestInfo | null {

    if (!response) {
      return null;
    }

    const data = structuredClone(response);

    // Fix dates
    data.EndUTC = new Date(data.EndUTC.replace(/ /g, 'T') + 'Z');
    data.StartUTC = new Date(data.StartUTC.replace(/ /g, 'T') + 'Z');

    return data;
  }
}
